
export enum TranslatedTerms {
    SIGNUP = "SIGNUP",
    LOGIN = "LOGIN",
    PASSWORD = "PASSWORD",
    MFA = "MFA",
    FORGOT_PASSWORD = "FORGOT_PASSWORD",
    SETUP_NEW_PASSWORD = "SETUP_NEW_PASSWORD",

    NAME = "NAME",
    ADDRESS = "ADDRESS",
    ZIP_AND_CITY = "ZIP_AND_CITY",
    PASSPORT = "PASSPORT",
    PHONE = "PHONE",
    COMPNAY_ID = "COMPNAY_ID",
    HOME = "HOME",
    PROFILE = "PROFILE",
    PROJECTS = "PROJECTS",
    PROJECT = "PROJECT",
    FEED = "FEED",
    ACTIVITY = "ACTIVITY",
    DATE = "DATE",
    MONTHS = "MONTHS",
    RETURN_PAYMENT_DATE = "RETURN_PAYMENT_DATE",
    UNKNOWN = "UNKNOWN",
    GO_BACK = "GO_BACK",

    DEPOSIT_RECIVED = "DEPOSIT_RECIVED",

    SEE_PROJECT = "SEE_PROJECT",
    SHARE_VIA = "SHARE_VIA",
    BUILDING_FINANCEING = "BUILDING_FINANCEING",
    CONTACT = "CONTACT",
    CONTRACT = "CONTRACT",
    CONTRACT_SIGNED = "CONTRACT_SIGNED",
    SIGN_CONTRACT = "SIGN_CONTRACT",
    FAQ = "FAQ",
    GENERAL = "GENERAL",
    SUPPORT = "SUPPORT",
    USER_POLICY = "USER_POLICY",
    PRIVACY_POLICY = "PRIVACY_POLICY",
    RISK_POLICY = "RISK_POLICY",
    COOKIE_POLICY = "COOKIE_POLICY",
    LOG_OUT = "LOG_OUT",
    CLOSE_MENU = "CLOSE_MENU",
    MENU = "MENU",
    FIRST_NAME = "FIRST_NAME",
    LAST_NAME = "LAST_NAME",
    PROVIDE_YOUR_ACCOUNT_NAME = "PROVIDE_YOUR_ACCOUNT_NAME",
    EMAIL_ADDRESS = "EMAIL_ADDRESS",
    IDENTIFICATION = "IDENTIFICATION",
    FILE_FOR = "FILE_FOR",
    IS_UPLOADED = "IS_UPLOADED",
    SEND_FOR_APPROVAL = "SEND_FOR_APPROVAL",
    COUNTRY = "COUNTRY",
    LANGUAGE = "LANGUAGE",
    STATUS = "STATUS",
    COMPLETE_INVESTMENT = "COMPLETE_INVESTMENT",
    COMPLETE_PROFILE = "COMPLETE_PROFILE",
    ACCEPT_NEWSLETTER_DESCRIPTION = "ACCEPT_NEWSLETTER_DESCRIPTION",
    ACCEPT_TERMS_DESCRIPTION = "ACCEPT_TERMS_DESCRIPTION",
    READ_MORE = "READ_MORE",
    AND_A_LAST_THING = "AND_A_LAST_THING",
    NAME_CONTRY_LANGUAGE_DESCRIPTION = "NAME_CONTRY_LANGUAGE_DESCRIPTION",
    RESET_USER = "RESET_USER",
    RESET_USER_WARNING_DESCRIPTION = "RESET_USER_WARNING_DESCRIPTION",
    RESET_USER_DESCRIPTION = "RESET_USER_DESCRIPTION",

    IDENTIFICATION_DESCRIPTION = "IDENTIFICATION_DESCRIPTION",
    BANK_ACCOUNT_DESCRIPTION = "BANK_ACCOUNT_DESCRIPTION",
    SOCIAL_SECURITY_NUMBER = "SOCIAL_SECURITY_NUMBER",

    COMPANY_PASSPORT = "COMPANY_PASSPORT",
    COMPANY_PASSPORT_DESCRIPTION = "COMPANY_PASSPORT_DESCRIPTION",
    REGISTER_OF_OWNERS = "REGISTER_OF_OWNERS",
    REGISTER_OF_OWNERS_DESCRIPTION = "REGISTER_OF_OWNERS_DESCRIPTION",
    COMPANY_IDENTIFICATION = "COMPANY_IDENTIFICATION",
    COMPANY_IDENTIFICATION_DESCRIPTION = "COMPANY_IDENTIFICATION_DESCRIPTION",
    INSTRUMENT_OF_INCORPORATION = "INSTRUMENT_OF_INCORPORATION",
    INSTRUMENT_OF_INCORPORATION_DESCRIPTION = "INSTRUMENT_OF_INCORPORATION_DESCRIPTION",
    ARE_YOU_SURE = "ARE_YOU_SURE",
    NEXT = "NEXT",
    BACK = "BACK",
    CANCEL = "CANCEL",
    FILL_DATA = "FILL_DATA",
    AWAIT_APPROVAL = "AWAIT_APPROVAL",
    APPROVED = "APPROVED",
    KYC_INCOMPLETE_MESSAGE = "KYC_INCOMPLETE_MESSAGE",
    KYC_PENDING_MESSAGE = "KYC_PENDING_MESSAGE",
    COMPANY_ACCOUNT = "COMPANY_ACCOUNT",
    SEE_PROJECT_DETAILS = "SEE_PROJECT_DETAILS",
    AMOUNT_INSUFFICIENT = "AMOUNT_INSUFFICIENT",

    INTEREST_CALCULATED_BASED_ON_X_MONTHS = "INTEREST_CALCULATED_BASED_ON_X_MONTHS",
    INTEREST_CALCULATED_BASED_ON_AVAGE_MONTHS = "INTEREST_CALCULATED_BASED_ON_AVAGE_MONTHS",

    INVESTMENT_STEP_AMOUNT_TITLE = "INVESTMENT_AMOUNT_TITLE",
    INVESTMENT_STEP_AMOUNT_DESCRIPTION = "INVESTMENT_AMOUNT_DESCRIPTION",
    INVESTMENT_STEP_KYC_TITLE = "INVESTMENT_STEP_KYC_TITLE",
    INVESTMENT_STEP_KYC_DESCRIPTION = "INVESTMENT_STEP_KYC_DESCRIPTION",
    INVESTMENT_STEP_TERMS_TITLE = "INVESTMENT_STEP_TERMS_TITLE",
    INVESTMENT_STEP_TERMS_DESCRIPTION = "INVESTMENT_STEP_TERMS_DESCRIPTION",
    INVESTMENT_STEP_INVESTOR_SIMULATION_TITLE = "INVESTMENT_STEP_INVESTOR_SIMULATION_TITLE",
    INVESTMENT_STEP_INVESTOR_SIMULATION_DESCRIPTION = "INVESTMENT_STEP_INVESTOR_SIMULATION_DESCRIPTION",
    INVESTMENT_STEP_INVESTOR_TEST_TITLE = "INVESTMENT_STEP_INVESTOR_TEST_TITLE",
    INVESTMENT_STEP_INVESTOR_TEST_DESCRIPTION = "INVESTMENT_STEP_INVESTOR_TEST_DESCRIPTION",
    INVESTMENT_STEP_SIGN_TITLE = "INVESTMENT_STEP_SIGN_TITLE",
    INVESTMENT_STEP_SIGN_DESCRIPTION = "INVESTMENT_STEP_SIGN_DESCRIPTION",
    INVESTMENT_STEP_PAYMENT_TITLE = "INVESTMENT_STEP_PAYMENT_TITLE",
    INVESTMENT_STEP_PAYMENT_DESCRIPTION = "INVESTMENT_STEP_PAYMENT_DESCRIPTION",
    INVESTMENT_STEP_SUCESS_TITLE = "INVESTMENT_STEP_SUCESS_TITLE",
    INVESTMENT_STEP_SUCESS_DESCRIPTION = "INVESTMENT_STEP_SUCESS_DESCRIPTION",
    INVESTMENT_STEP_SUB_SUCESS_DESCRIPTION = "INVESTMENT_STEP_SUB_SUCESS_DESCRIPTION",

    INVESTMENT_STEP_TERMS_RISK = "INVESTMENT_STEP_TERMS_RISK",
    INVESTMENT_STEP_TERMS_POLICY = "INVESTMENT_STEP_TERMS_POLICY",
    INVESTMENT_STEP_TERMS_MARKETING = "INVESTMENT_STEP_TERMS_MARKETING",

    RELOAD = "RELOAD",
    OPEN_CONTRACT = "OPEN_CONTRACT",
    PROBLEMS_OPENING_THE_LINK_CLICK_HERE = "PROBLEMS_OPENING_THE_LINK_CLICK_HERE",

    VIEW_DETAILS = "VIEW_DETAILS",
    CREATED = "CREATED",
    DETAILS = "DETAILS",


    AMOUNT = "AMOUNT",
    BANK = "BANK",
    BANK_ACCOUNT = "BANK_ACCOUNT",
    PAYMENT_REFERENCE = "PAYMENT_REFERENCE",
    PAYMENT_REFERENCE_TOOLTIP = "PAYMENT_REFERENCE_TOOLTIP",
    PAYMENT_DEADLINE = "PAYMENT_DEADLINE",
    PAYMENT_DEADLINE_DESCRIPTION = "PAYMENT_DEADLINE_DESCRIPTION",
    FUNDING_TARGET = "FUNDING_TARGET",
    CURRENT_FUNDING = "CURRENT_FUNDING",
    PROJECT_SIZE = "PROJECT_SIZE",
    MIN_INVESTMENT = "MIN_INVESTMENT",
    INTEREST_RATE_PR_Y = "INTEREST_RATE_PR_Y",
    INTEREST_RATE = "INTEREST_RATE",
    PROJECT_START = "PROJECT_START",
    PROJECT_END = "PROJECT_END",

    DURATION = "DURATION",
    PRINCIPAL = "PRINCIPAL",

    MTH = "MTH",
    COVER = "COVER",
    A_GOOD_INVESTMENT = "A_GOOD_INVESTMENT",
    INVEST_NOW = "INVEST_NOW",
    DESIRED_LENDING_AMOUNT = "DESIRED_LENDING_AMOUNT",

    CAPITAL_SOURCE_DESCRIPTION = "CAPITAL_SOURCE_DESCRIPTION",
    SALARY_PENSION = "SALARY_PENSION",
    SAVINGS = "SAVINGS",
    HERITAGE_GIFT = "HERITAGE_GIFT",
    LOTTERY = "LOTTERY",
    INTREST_REVENUE = "INTREST_REVENUE",
    PAID_BACK = "PAID_BACK",
    OTHER = "OTHER",
    INCOMPLETE = "INCOMPLETE",
    LATEST_INVESTMENT = "LATEST_INVESTMENT",
    ACCOUNT_VALUE = "ACCOUNT_VALUE",
    ALL_ACCOUNTS = "ALL_ACCOUNTS",
    SELECT_ACCOUNT = "SELECT_ACCOUNT",
    SELECT_ONE = "SELECT_ONE",
    WHERE_HAVE_YOU_HEARD_ABOUT_FUNDBRICKS = "WHERE_HAVE_YOU_HEARD_ABOUT_FUNDBRICKS",
    NAME_OF_FUNDBRICKS_REP = "NAME_OF_FUNDBRICKS_REP",
    CREATE_NEW_ACCOUNT = "CREATE_NEW_ACCOUNT",
    INVEST = "INVEST",
    FOLLOW = "FOLLOW",
    FOLLOWING = "FOLLOWING",
    PROJECT_NEWS = "PROJECT_NEWS",
    NO_MORE_NEWS = "NO_MORE_NEWS",
    SUBSCRIPTION_LIST = "SUBSCRIPTION_LIST",
    GO_TO_PROJECT = "GO_TO_PROJECT",
    GO_TO_DASHBOARD = "GO_TO_DASHBOARD",
    GO_TO_DETAILS = "GO_TO_DETAILS",
    COMPLETED = "COMPLETED",
    PAID_BACK_INVESTMENTS = "PAID_BACK_INVESTMENTS",
    ACTIVE_INVESTMENTS = "ACTIVE_INVESTMENTS",
    HOW_MUCH_DO_YOU_PLAN_ON_LENDING_OUT = "HOW_MUCH_DO_YOU_PLAN_ON_LENDING_OUT",
    _LESS_THAN_100_000_DKK = "_LESS_THAN_100_000_DKK",
    _100_000_TO_750_000_DKK = "_100_000_TO_750_000_DKK",
    _750_000_TO_2_000_000_DKK = "_750_000_TO_2_000_000_DKK",
    _MORE_THAN_2_000_000_DKK = "_MORE_THAN_2_000_000_DKK",
    WHY_WILL_YOU_RENT_OUT_CAPITAL = "WHY_WILL_YOU_RENT_OUT_CAPITAL",
    OPTIMIZE_CAPITAL_OR_PENSION = "OPTIMIZE_CAPITAL_OR_PENSION",
    AS_GIFT_TO_RELATIVE = "AS_GIFT_TO_RELATIVE",
    ALTERNATIVE_TO_DONATIONS = "ALTERNATIVE_TO_DONATIONS",
    TRADING = "TRADING",
    EXPECTED_RETURN = "EXPECTED_RETURN",
    VALUE = "VALUE",
    VOLUME = "VOLUME",
    WELCOME_TO_FUNDBRICKS = "WELCOME_TO_FUNDBRICKS",
    DASHBOARD_DESCRIPTION = "DASHBOARD_DESCRIPTION",
    NO_INVESTMENTS = "NO_INVESTMENTS",
    NO_COMPLETED_INVESTMENTS = "NO_COMPLETED_INVESTMENTS",
    NO_ACTIVITY = "NO_ACTIVITY",
    INVESTED_PROJECTS = "INVESTED_PROJECTS",
    PROFILE_PAGE_DESCRIPTION = "PROFILE_PAGE_DESCRIPTION",
    HOW_DOES_IT_WORK = "HOW_DOES_IT_WORK",
    GO_BACK_TO_FEED = "GO_BACK_TO_FEED",

    PROJECT_COMMING_SOON = "PROJECT_COMMING_SOON",
    PROJECT_WAITING_FOR_START = "PROJECT_WAITING_FOR_START",
    PROJECT_IN_PROGRESS = "PROJECT_IN_PROGRESS",
    PROJECTS_IN_PROGRESS = "PROJECTS_IN_PROGRESS",
    PROJECT_IN_COMPLETED = "PROJECT_IN_COMPLETED",
    PROJECTS_IN_COMPLETED = "PROJECTS_IN_COMPLETED",
    PROJECT_OPEN_FOR_INVESTMENT = "PROJECT_OPEN_FOR_INVESTMENT",
    IN_X_MONTHS_YOU_WILL_HAVE_RECIVED_X_AMOUNT_NOT_BAD_HUH = "IN_X_MONTHS_YOU_WILL_HAVE_RECIVED_X_AMOUNT_NOT_BAD_HUH",

    INVESTMENT = "INVESTMENT",
    INVESTMENT_PROJECT_LABEL_DESCRIPTION = "INVESTMENT_PROJECT_LABEL_DESCRIPTION",
    INVESTMENT_PROJECT_LABEL_DOCUMENT = "INVESTMENT_PROJECT_LABEL_DOCUMENT",
    BUILDING_DEVELOPER = "BUILDING_DEVELOPER",
    BUILDING_DEVELOPER_PROJECT_LABEL_DESCRIPTION = "BUILDING_DEVELOPER_PROJECT_LABEL_DESCRIPTION",
    PROJECT_COMPANY = "PROJECT_COMPANY",
    PROJECT_COMPANY_PROJECT_LABEL_DESCRIPTION = "PROJECT_COMPANY_PROJECT_LABEL_DESCRIPTION",
    DEPOSIT_ACCOUNT = "DEPOSIT_ACCOUNT",
    DEPOSIT_ACCOUNT_PROJECT_LABEL_DESCRIPTION = "DEPOSIT_ACCOUNT_PROJECT_LABEL_DESCRIPTION",
    CROWDINVESTOR = "CROWDINVESTOR",
    CROWDINVESTOR_PROJECT_LABEL_DESCRIPTION = "CROWDINVESTOR_PROJECT_LABEL_DESCRIPTION",
    BANK_FINANCEING = "BANK_FINANCEING",
    BANK_FINANCEING_PROJECT_LABEL_DESCRIPTION = "BANK_FINANCEING_PROJECT_LABEL_DESCRIPTION",
    FUNDBRICKS_PROJECT_LABEL_DESCRIPTION = "FUNDBRICKS_PROJECT_LABEL_DESCRIPTION",
    PROJECT_PROJECT_LABEL_DESCRIPTION = "PROJECT_PROJECT_LABEL_DESCRIPTION",
    CONSTRUCTION_EXPERT = "CONSTRUCTION_EXPERT",
    CONSTRUCTION_EXPERT_PROJECT_LABEL_DESCRIPTION = "CONSTRUCTION_EXPERT_PROJECT_LABEL_DESCRIPTION",
    SALES_PERIOD = "SALES_PERIOD",
    SALES_PERIOD_PROJECT_LABEL_DESCRIPTION = "SALES_PERIOD_PROJECT_LABEL_DESCRIPTION",
    RETURN_PAYMENT = "RETURN_PAYMENT",
    RETURN_PAYMENT_PROJECT_LABEL_DESCRIPTION = "RETURN_PAYMENT_PROJECT_LABEL_DESCRIPTION",
    BANK_RETURN_PAYMENT = "BANK_RETURN_PAYMENT",
    BANK_RETURN_PAYMENT_PROJECT_LABEL_DESCRIPTION = "BANK_RETURN_PAYMENT_PROJECT_LABEL_DESCRIPTION",
    CROWDINVESTOR_RETURN_PAYMENT = "CROWDINVESTOR_RETURN_PAYMENT",
    CROWDINVESTOR_RETURN_PAYMENT_PROJECT_LABEL_DESCRIPTION = "CROWDINVESTOR_RETURN_PAYMENT_PROJECT_LABEL_DESCRIPTION",
    DEVELOPER_RETURN_PAYMENT = "DEVELOPER_RETURN_PAYMENT",
    DEVELOPER_RETURN_PAYMENT_PROJECT_LABEL_DESCRIPTION = "DEVELOPER_RETURN_PAYMENT_PROJECT_LABEL_DESCRIPTION",
    ECONOMY = "ECONOMY",
    ECONOMY_PROJECT_LABEL_DESCRIPTION = "ECONOMY_PROJECT_LABEL_DESCRIPTION",
    RISK = "RISK",
    RISK_PROJECT_LABEL_DESCRIPTION = "RISK_PROJECT_LABEL_DESCRIPTION",

    ONBOARDING_ERROR_TERMS_MESSAGE = "ONBOARDING_ERROR_TERMS_MESSAGE",
    ONBOARDING_ERROR_FIELDS_MESSAGE = "ONBOARDING_ERROR_FIELDS_MESSAGE",
    ONBOARDING_ERROR_CONTRY_MESSAGE = "ONBOARDING_ERROR_CONTRY_MESSAGE",
    DELETE = "DELETE",
    NOTIFICATIONS = "NOTIFICATIONS",
    RISK_WARNING = "RISK_WARNING",
    RISK_WARNING_LESS_EXPERIENCEDP1 = "RISK_WARNING_LESS_EXPERIENCEDP1",
    RISK_WARNING_LESS_EXPERIENCEDP2 = "RISK_WARNING_LESS_EXPERIENCEDP2",
    RISK_WARNING_LESS_EXPERIENCEDP3 = "RISK_WARNING_LESS_EXPERIENCEDP3",
    RISK_WARNING_LESS_EXPERIENCED_ACCEPTENCE = "RISK_WARNING_LESS_EXPERIENCED_ACCEPTENCE",
    APPLY_FOR_MORE_EXPERIENCED_BUTTON = "APPLY_FOR_MORE_EXPERIENCED_BUTTON",
    PENSION = "PENSION",
    LOW = "LOW",
    MEDIUM = "MEDIUM",
    HIGH = "HIGH",
    DONTKNOW = "DONTKOWN",
    YES = "YES",
    NO = "NO",
    ADD = "ADD",

    DOWNLOAD_CENTRAL_INVESTORINFORMATION = "DOWNLOAD_CENTRAL_INVESTORINFORMATION",
    CVR_OR_COMANY_REGISTRATION = "CVR_OR_COMANY_REGISTRATION",
    PEP_LIST_MEMBER="PEP_LIST_MEMBER",

    DOCUMENTS="DOCUMENTS",
    OPEN_DOCUMENT="OPEN_DOCUMENT",
    LATEST_VERSION= "LATEST_VERSION",
    MESSAGES= "MESSAGES",
    MORARENTE= "MORARENTE",

    SIMULATION_RESULT="SIMULATION_RESULT",

    PROJECT_FAILED = "PROJECT_FAILED",
    PROJECT_FAILED_PROCESS = "PROJECT_FAILED_PROCESS",
    INVESTMENT_LOSS_DESCRIPTION= "INVESTMENT_LOSS_DESCRIPTION",
    INVESTMENT_FAIL_PROCESS_DESCRIPTION= "INVESTMENT_FAIL_PROCESS_DESCRIPTION"
}